<template>
    <div>
        <vs-row>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <vs-input
                    :value="data_obj.data.id ? `Entry #${data_obj.data.id}` : 'Auto Generated'"
                    label="* Issue ID"
                    readonly
                    class="w-full"
                />
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <SelectForeign
                    :model="data_obj.added_by"
                    label="Added By"
                    placeholder="Auto Filled"
                    :multiple="false"
                    :load_initial="false"
                    :label_keys="['first_name', 'last_name']"
                    :show_id_in_label="true"
                    :endpoint="`${$store.state.apiendpoints.organisation_users}?is_active=true`"
                    container_class="w-full"
                    input_class=""
                    :use_id_as_value="false"
                    :disabled="true"
                />
                <small class="block text-danger mt-1" v-if="api_errors.added_by">
                    {{ api_errors.added_by.join(', ') }}
                </small>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <SelectDate
                    class="w-full"
                    :selectedDate.sync="data_obj.date"
                    label="Date *"
                    :disabled="mode != 'e'"
                />
                <small class="block text-danger mt-1" v-if="api_errors.date">
                    {{ api_errors.date.join(', ') }}
                </small>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <SelectForeign
                    :model.sync="data_obj.data.type_of_road"
                    label="Type Of Road"
                    placeholder="Type to Search..."
                    :multiple="false"
                    :load_initial="true"
                    :label_keys="['name',]"
                    :show_id_in_label="false"
                    :endpoint="`${$store.state.apiendpoints.data_type_of_roads}?active=true`"
                    container_class="w-full"
                    input_class=""
                    :use_id_as_value="false"
                    :disabled="mode != 'e'"
                    :use_cache="true"
                />
                <small class="block text-danger mt-1" v-if="api_errors.type_of_road">
                    {{ api_errors.type_of_road.join(', ') }}
                </small>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="6" vs-lg="4" class="mb-3">
                <label class="vs-input--label block">Side</label>
                <div class="flex mt-3 align-center">
                    <vs-radio :disabled="mode != 'e'" v-model="data_obj.data.side" vs-name="side" vs-value="lhs">LHS</vs-radio>
                    <vs-radio :disabled="mode != 'e'" v-model="data_obj.data.side" vs-name="side" vs-value="rhs" class="mx-3">RHS</vs-radio>
                    <vs-radio :disabled="mode != 'e'" v-model="data_obj.data.side" vs-name="side" vs-value="junctions" class="mx-3">Junctions</vs-radio>
                    <vs-radio :disabled="mode != 'e'" v-model="data_obj.data.side" vs-name="side" vs-value="median" class="mx-3">Median</vs-radio>
                </div>
                <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.side">
                    {{ api_errors.data.side.join(', ') }}
                </small>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="6" vs-lg="4" class="mb-3">
                <label class="vs-input--label block">Chainage</label>
                <vs-row class="mt-1">
                    <vs-col vs-xs="6" vs-sm="6" vs-lg="6" class="pl-0 pr-1">
                        <div class="flex" style="align-items: center">
                            <label class="vs-input--label block mr-3">From</label>
                            <vs-input
                                v-model="data_obj.data.chainage_from"
                                class="w-full"
                                :disabled="mode != 'e'"
                                type="Number"
                                />
                        </div>
                        <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.chainage_from">
                            {{ api_errors.data.chainage_from.join(', ') }}
                        </small>
                    </vs-col>
                    <vs-col vs-xs="6" vs-sm="6" vs-lg="6" class="pl-1 pr-0">
                        <div class="flex" style="align-items: center">
                            <label class="vs-input--label block mr-3">To</label>
                            <vs-input
                                v-model="data_obj.data.chainage_to"
                                class="w-full"
                                :disabled="mode != 'e'"
                                type="Number"
                            />
                        </div>
                        <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.chainage_to">
                            {{ api_errors.data.chainage_to.join(', ') }}
                        </small>
                    </vs-col>
                </vs-row>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <vs-input
                    v-model="data_obj.data.width"
                    label="Width (m)"
                    class="w-full"
                    type="Number"
                    :disabled="mode != 'e'"
                />
                <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.width">
                    {{ api_errors.data.width.join(', ') }}
                </small>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <vs-input
                    v-model="data_obj.data.length"
                    label="Length (km)"
                    class="w-full"
                    type="Number"
                    readonly
                />
                <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.length">
                    {{ api_errors.data.length.join(', ') }}
                </small>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <vs-input
                    v-model="data_obj.data.avg_daily_density"
                    label="Avg. Daily Density as per Lab reports"
                    class="w-full"
                    type="Number"
                    :disabled="mode != 'e'"
                />
                <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.avg_daily_density">
                    {{ api_errors.data.avg_daily_density.join(', ') }}
                </small>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <vs-input
                    v-model="data_obj.data.tonage_bc_mix_swb"
                    label="Tonage of BC Mix from SWB"
                    class="w-full"
                    type="Number"
                    :disabled="mode != 'e'"
                />
                <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.tonage_bc_mix_swb">
                    {{ api_errors.data.tonage_bc_mix_swb.join(', ') }}
                </small>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <vs-input
                    v-model="data_obj.data.tonage_bc_mix_hmp"
                    label="Tonage of BC Mix from HMP"
                    class="w-full"
                    type="Number"
                    :disabled="mode != 'e'"
                />
                <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.tonage_bc_mix_hmp">
                    {{ api_errors.data.tonage_bc_mix_hmp.join(', ') }}
                </small>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4">
                <label class="vs-input--label block mb-1">Remarks</label>
                <vs-textarea v-model="data_obj.data.remarks" :disabled="mode != 'e'" />
                <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.remarks">
                    {{ api_errors.data.remarks.join(', ') }}
                </small>
            </vs-col>
        </vs-row>
        <vs-row>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="px-0">
                <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mb-3">
                    <label class="vs-input--label block mb-1" v-if="mode == 'v'">Images</label>
                    <FileSelection
                        :images.sync="data_obj.images"
                        :filter="val => val.image_type == undefined || val.image_type == null || val.image_type == 'p'"
                        :read_only="mode != 'e'"
                    />
                    <small class="block text-danger mt-1" v-if="api_errors.images">
                        {{ api_errors.images.join(', ') }}
                    </small>
                </vs-col>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="8" vs-lg="8" class="px-0">
                <LocationChooser :disabled="mode != 'e'" :latitude.sync="data_obj.data.location_latitude" :longitude.sync="data_obj.data.location_longitude" :api_errors="{latitude: api_errors.data ? api_errors.data.location_latitude : null, longitude: api_errors.data ? api_errors.data.location_longitude : null}" />
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
import LocationChooser from "../../../Issue/Components/LocationChooser.vue"
import FileSelection from "../../../Issue/Components/FileSelection.vue"

export default {
    props: {
        data: {
            required: true,
            type: Object
        },
        api_errors: {
            required: true,
            type: Object
        },
        mode: {
            required: true,
            type: String
        }
    },
    components: {
        FileSelection,
        LocationChooser
    },
    data() {
        return {
            data_obj: this.data,

            default_data: {
                chainage_from: null,
                chainage_to: null,
                remarks: null,

                side: null,

                width: null,
                length: null,
                avg_daily_density: null,
                tonage_bc_mix_swb: null,
                tonage_bc_mix_hmp: null,
                location_latitude: null,
                location_longitude: null,
                type_of_road: null
            }
        }
    },
    watch: {
        data: {
            deep: true,
            handler: function (newV) {
                this._set_by_watcher = true
                this.update_data_obj(newV)
            }
        },
        data_obj: {
            deep: true,
            handler: function (newV) {
                if (this._set_by_watcher) {
                    this._set_by_watcher = false
                    return
                }
                this.$emit('update:data', newV)
            }
        },
        'data_obj.data.chainage_from'() {
            this.update_length()
        },
        'data_obj.data.chainage_to'() {
            this.update_length()
        }
    },
    mounted() {
        this.update_data_obj(this.data)
    },
    methods: {
        update_data_obj(new_data) {
            if (!new_data) this.data_obj = null
            else {
                let data_obj = {...new_data}
                if (!data_obj.data || Object.keys(data_obj.data).length == 0)
                    data_obj.data = this.deepclone(this.default_data)

                this.data_obj = data_obj
            }
        },
        update_length() {
            let from = this.data_obj.data.chainage_from || 0
            let to = this.data_obj.data.chainage_to || 0

            this.$set(this.data_obj.data, 'length' ,parseFloat((parseFloat(to) - parseFloat(from)).toFixed(3)))
            this.$set(this.data_obj.data, 'cumm_length', this.data_obj.data.length)
        }
    }
}
</script>
